export const KundenPageKey = "kunden-page";
export const KundenSearchValueKey = "kunden-searchValue";
export const KundenShowInactiveKey = "kunden-showInactive";
export const KundenTableSchemeKey = "kunden-tableScheme";
export const PackagesSearchValue = "packages-search-value";
export const ProjektSearchValue = "projekt-search-value";
export const ReportsSearchValue = "reports-search-value";
export const TestSearchValue = "test-search-value";
export const UserSearchValue = "user-search-value";

/** @var searchKeys - domain -> session storage keys */
export const searchKeys: Record<string, string[]> = {
  "/entwicklung": [ProjektSearchValue, PackagesSearchValue, TestSearchValue],
  "/kunde": [
    ReportsSearchValue,
    KundenSearchValueKey,
    KundenPageKey,
    KundenTableSchemeKey,
    KundenShowInactiveKey,
  ],
  "/administration": [UserSearchValue],
};
